export const environment = {
  production: true,
  buildId: '3486512494622371',
  configFile: 'config.json',
};
